import React from 'react';
import { Provider, observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import './styles.scss';
import {
  FormGroup,
  ControlLabel,
  ButtonToolbar,
  Button,
  SplitButton,
  MenuItem
} from 'react-bootstrap';
import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import TextareaAutosize from 'react-autosize-textarea';
import FeedbackChain from './models/FeedbackChain';
import UserSelect from '../common_components/UserSelect';

@injectIntl
@inject('rootStore', 'feedbackChainsStore')
@observer
export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    const { intl } = this.props;
    const feedbackChain = this.props.feedbackChainsStore.buildFeedbackChain();
    let formElement = <FormFields feedbackChain={feedbackChain} />;
    if (this.props.feedbackChainsStore.loading) {
      formElement = (
        <div className="form-container text-center">
          <div className="main-loader">
            <div className="loader-lg"></div>
          </div>
          <span>{intl.formatMessage({ id: 'loading' })}</span>
        </div>
      );
    }
    if (this.props.feedbackChainsStore.lastFeedbackPath) {
      setTimeout(
        () => this.props.feedbackChainsStore.clearLastFeedbackPath(),
        3000
      );
      formElement = (
        <div className="form-container">
          <h4 className="bold">
            {intl.formatMessage({ id: 'new_feedback_chain_sent' })}
          </h4>
          <br />
          <a href={this.props.feedbackChainsStore.lastFeedbackPath}>
            {intl.formatMessage({ id: 'new_feedback_chain_link_message' })}
          </a>
          <br />
          <Button
            className="pull-right"
            bsStyle={'primary'}
            onClick={() =>
              this.props.feedbackChainsStore.clearLastFeedbackPath()
            }
          >
            <i className="fa fa-arrow-left" />
            &nbsp;{intl.formatMessage({ id: 'back' })}
          </Button>
        </div>
      );

      setInterval;
    }
    return (
      <div className={'support-form'}>
        {this.state.open && formElement}
        <button
          title={intl.formatMessage({ id: 'support_title' })}
          type="button"
          className={'launcher ' + (this.state.open ? 'open' : '')}
          onClick={this.toggleOpen}
        >
          <i
            className={
              'fa ' +
              (this.state.open
                ? 'fa-remove open-launcher'
                : 'fa-life-saver close-launcher')
            }
          />
        </button>
      </div>
    );
  }

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  };
}

@injectIntl
@inject('rootStore', 'feedbackChainsStore')
@observer
class FormFields extends React.Component {
  render() {
    const { intl, feedbackChain } = this.props;
    const disableSend = !feedbackChain.isValid();
    const categories = Object.values(FeedbackChain.categories);
    if (!this.props.rootStore.currentUserBelongsToMainStartup) {
      const index = categories.indexOf(FeedbackChain.categories.INTERNAL);
      if (index !== -1) {
        categories.splice(index, 1);
      }
    }
    return (
      <div className="form-container">
        <FormGroup>
          <h4 className="bold">{intl.formatMessage({ id: 'form-title' })}</h4>
          <br />

          <SplitButton
            bsStyle={'default'}
            title={intl.formatMessage({ id: feedbackChain.category })}
            key={feedbackChain.category}
            id={'feedback-chain-form-category'}
          >
            {categories.map((s, idx) => (
              <MenuItem
                key={idx}
                className={s}
                eventKey={s}
                onSelect={k => feedbackChain.setCategory(k)}
              >
                {intl.formatMessage({ id: s })}
              </MenuItem>
            ))}
          </SplitButton>
          <br />

          {this.props.rootStore.currentUserBelongsToMainStartup && (
            <div>
              <UserSelect
                users={feedbackChain.notifiables}
                value={feedbackChain.selectedNotifiables}
                onChange={this.handleChangeNotifiableSelect}
                multi={true}
                placeholder={intl.formatMessage({
                  id: 'notifiables_placeholder'
                })}
                style={{ marginTop: '5px' }}
              />
              <br />
            </div>
          )}

          <TextareaAutosize
            className="editable-text-area title form-control"
            value={feedbackChain.title}
            placeholder={intl.formatMessage({ id: 'form_title_placeholder' })}
            onChange={e => feedbackChain.setTitle(e.target.value)}
            rows={1}
            maxRows={3}
          />
          <TextareaAutosize
            className="editable-text-area form-control"
            value={feedbackChain.description}
            placeholder={intl.formatMessage({
              id: 'form_description_placeholder'
            })}
            onChange={e => feedbackChain.setDescription(e.target.value)}
            rows={3}
            maxRows={7}
          />
          <AttachmentsForm attachable={feedbackChain} />
          <ButtonToolbar>
            <Button
              disabled={disableSend}
              className={'pull-right'}
              bsStyle={'primary'}
              onClick={this.handleSend}
              block
            >
              {intl.formatMessage({ id: 'send' })}
            </Button>
            <Button
              className={'pull-right'}
              bsStyle={'default'}
              onClick={() => feedbackChain.cancelEdition()}
              block
            >
              {intl.formatMessage({ id: 'clean' })}
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </div>
    );
  }

  handleChangeNotifiableSelect = members => {
    this.props.feedbackChain.setSelectedNotifiables(members);
  };

  handleSend = () => {
    this.props.feedbackChain.persist();
  };
}
